/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M16.0001 15.0002L9.13565 21.8646C9.04883 21.9514 8.93108 22.0002 8.80831 22.0002V22.0002C7.47891 22.0002 6.58261 20.6409 7.10628 19.419L8.40006 16.4002C8.40236 16.3948 8.40352 16.3921 8.40436 16.3901C8.68287 15.7325 8.20204 15.0033 7.48783 15.0002C7.48568 15.0002 7.48275 15.0002 7.47691 15.0002H6.00006"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18.0001 4.00018V4.00018C18.0001 2.89561 18.8955 2.00018 20.0001 2.00018V2.00018C21.1046 2.00018 22.0001 2.89561 22.0001 4.00018V13.0002C22.0001 14.1048 21.1046 15.0002 20.0001 15.0002V15.0002C18.8955 15.0002 18.0001 14.1048 18.0001 13.0002V13.0002M18.0001 4.00018V13.0002M18.0001 4.00018C18.0001 4.00018 17.0001 2.00018 15.0001 2.00018H7.11807C5.65659 2.00018 4.92585 2.00018 4.33564 2.26762C3.81546 2.50332 3.37336 2.88261 3.0613 3.3609C2.70723 3.90358 2.59612 4.62582 2.37389 6.07031L1.85081 9.47031C1.55771 11.3755 1.41115 12.3281 1.69386 13.0693C1.942 13.7199 2.40871 14.2639 3.01398 14.6081C3.70359 15.0002 4.66739 15.0002 6.595 15.0002H7.00006M18.0001 13.0002L16.0001 15.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M8.4 16.4L7.10622 19.4188C6.58255 20.6407 7.47885 22 8.80825 22C8.93102 22 9.04877 21.9512 9.13559 21.8644L18 13V4C18 4 17 2 15 2H7.11801C5.65653 2 4.92579 2 4.33558 2.26743C3.8154 2.50314 3.3733 2.88242 3.06124 3.36072C2.70717 3.90339 2.59606 4.62564 2.37383 6.07012L1.84848 9.48487C1.55749 11.3763 1.41199 12.3221 1.68989 13.0588C1.93831 13.7174 2.41038 14.2676 3.02352 14.6133C3.70943 15 4.66629 15 6.58001 15H7.47685L7.48777 15C8.20198 15.0031 8.68281 15.7323 8.40429 16.39L8.4 16.4Z"
				fill="currentColor"
			/>
			<path
				d="M18 4V4C18 2.89543 18.8954 2 20 2V2C21.1046 2 22 2.89543 22 4V13C22 14.1046 21.1046 15 20 15V15C18.8954 15 18 14.1046 18 13V13M18 4V13M18 4C18 4 17 2 15 2H7.11801C5.65653 2 4.92579 2 4.33558 2.26743C3.8154 2.50314 3.3733 2.88242 3.06124 3.36072C2.70717 3.90339 2.59606 4.62564 2.37383 6.07012L1.84848 9.48487C1.55749 11.3763 1.41199 12.3221 1.68989 13.0588C1.93831 13.7174 2.41038 14.2676 3.02352 14.6133C3.70943 15 4.66629 15 6.58001 15H7.47685C7.48269 15 7.48562 15 7.48777 15C8.20198 15.0031 8.68281 15.7323 8.40429 16.39C8.40345 16.3919 8.4023 16.3946 8.4 16.4L7.10622 19.4188C6.58255 20.6407 7.47885 22 8.80825 22V22C8.93102 22 9.04877 21.9512 9.13559 21.8644L18 13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M9.15068 22.7502C9.33272 22.7502 9.50731 22.6779 9.63603 22.5491L15.0626 17.1226C16.1003 16.0849 16.6191 15.5661 16.9902 14.9606C17.3191 14.4237 17.5616 13.8385 17.7085 13.2262C17.8743 12.5357 17.8743 11.8019 17.8743 10.3344V6.05018C17.8743 4.37003 17.8743 3.52995 17.5473 2.88821C17.2597 2.32373 16.8008 1.86478 16.2363 1.57716C15.5946 1.25018 14.7545 1.25018 13.0743 1.25018H6.5989C5.13742 1.25018 4.40668 1.25018 3.81647 1.51762C3.29629 1.75332 2.85419 2.13261 2.54213 2.6109C2.18806 3.15358 2.07695 3.87582 1.85472 5.32031L1.26199 9.17301C0.98455 10.9764 0.845828 11.8781 1.00512 12.6057C1.29245 13.9181 2.21943 14.9986 3.47288 15.4821C4.16776 15.7502 5.08007 15.7502 6.90467 15.7502H7.14073C7.21846 15.7502 7.25732 15.7502 7.28581 15.7535C7.59489 15.789 7.7968 16.0952 7.70773 16.3933C7.69952 16.4208 7.68421 16.4565 7.65359 16.528L6.62711 18.9231C5.85066 20.7348 7.1796 22.7502 9.15068 22.7502Z"
				fill="currentColor"
			/>
			<path
				d="M19.1243 13.1252C19.1243 14.1607 19.9638 15.0002 20.9993 15.0002C22.0349 15.0002 22.8743 14.1607 22.8743 13.1252V3.12539C22.8743 2.08986 22.0349 1.25039 20.9993 1.25039C19.9638 1.25039 19.1243 2.08986 19.1243 3.1254V13.1252Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M18 4V4C18 2.89543 18.8954 2 20 2V2C21.1046 2 22 2.89543 22 4V13C22 14.1046 21.1046 15 20 15V15C18.8954 15 18 14.1046 18 13V13V10M18 4C18 4 17 2 15 2H7.11801C5.65653 2 4.92579 2 4.33558 2.26743C3.8154 2.50314 3.3733 2.88242 3.06124 3.36072C2.70717 3.90339 2.59606 4.62564 2.37383 6.07012L1.84848 9.48487C1.55749 11.3763 1.41199 12.3221 1.68989 13.0588C1.93831 13.7174 2.41038 14.2676 3.02352 14.6133C3.70943 15 4.66629 15 6.58001 15H7.47685C7.48269 15 7.48562 15 7.48777 15C8.20198 15.0031 8.68281 15.7323 8.40429 16.39C8.40345 16.3919 8.4023 16.3946 8.4 16.4L7.10622 19.4188C6.58255 20.6407 7.47885 22 8.80825 22V22C8.93102 22 9.04877 21.9512 9.13559 21.8644L15 16L15.5 15.5M18 4V6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M18.0001 4.00021V4.00021C18.0001 2.89564 18.8955 2.00021 20.0001 2.00021V2.00021C21.1046 2.00021 22.0001 2.89564 22.0001 4.00021V13.0002C22.0001 14.1048 21.1046 15.0002 20.0001 15.0002V15.0002C18.8955 15.0002 18.0001 14.1048 18.0001 13.0002V13.0002M18.0001 4.00021V13.0002M18.0001 4.00021C18.0001 4.00021 17.0001 2.00021 15.0001 2.00021H7.11807C5.65659 2.00021 4.92585 2.00021 4.33564 2.26765C3.81546 2.50335 3.37336 2.88264 3.0613 3.36093C2.70723 3.90361 2.59612 4.62585 2.37389 6.07034L1.84854 9.48509C1.55755 11.3766 1.41205 12.3223 1.68995 13.059C1.93837 13.7176 2.41045 14.2678 3.02358 14.6135C3.70949 15.0002 4.66635 15.0002 6.58007 15.0002H7.47691C7.48275 15.0002 7.48568 15.0002 7.48783 15.0002C8.20204 15.0033 8.68287 15.7325 8.40436 16.3902C8.40352 16.3922 8.40236 16.3948 8.40006 16.4002L7.10628 19.419C6.58261 20.6409 7.47891 22.0002 8.80831 22.0002V22.0002C8.93108 22.0002 9.04883 21.9514 9.13565 21.8646L18.0001 13.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.15068 22.75C9.33272 22.75 9.50731 22.6777 9.63603 22.549L15.0626 17.1224C16.1003 16.0847 16.6191 15.5659 16.9902 14.9604C17.3191 14.4235 17.5616 13.8383 17.7085 13.2261C17.8743 12.5355 17.8743 11.8018 17.8743 10.3342V6.05C17.8743 4.36984 17.8743 3.52976 17.5473 2.88803C17.2597 2.32354 16.8008 1.8646 16.2363 1.57698C15.5946 1.25 14.7545 1.25 13.0743 1.25H6.5989C5.13742 1.25 4.40668 1.25 3.81647 1.51743C3.29629 1.75314 2.85419 2.13242 2.54213 2.61072C2.18806 3.15339 2.07695 3.87564 1.85472 5.32013L1.26199 9.17283C0.98455 10.9762 0.845828 11.8779 1.00512 12.6055C1.29245 13.9179 2.21943 14.9984 3.47288 15.4819C4.16776 15.75 5.08007 15.75 6.90467 15.75H7.14073C7.21846 15.75 7.25732 15.75 7.28581 15.7533C7.59489 15.7888 7.7968 16.095 7.70773 16.3931C7.69952 16.4206 7.68421 16.4563 7.65359 16.5278L6.62711 18.9229C5.85066 20.7346 7.1796 22.75 9.15068 22.75Z"
				fill="currentColor"
			/>
			<path
				d="M19.1244 13.125C19.1244 14.1605 19.9639 15 20.9994 15C22.0349 15 22.8744 14.1605 22.8744 13.125V3.12521C22.8744 2.08968 22.0349 1.25021 20.9994 1.25021C19.9639 1.25021 19.1244 2.08968 19.1244 3.12521V13.125Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
